import { useMemo } from "react";

import type { ContentTypeDto } from "$src/core/models/dto";
import useEpisodeContentQuery from "$src/core/queries/use-episode-content-query";
import useLinearContentQuery from "$src/core/queries/use-linear-content-query";
import useMovieContentQuery from "$src/core/queries/use-movie-content-query";
import useSeriesContentQuery from "$src/core/queries/use-series-content-query";

type Variables = {
  id: string;
  type: ContentTypeDto;
};

const useContentQuery = ({ id, type }: Variables) => {
  const movieContentQuery = useMovieContentQuery(id, {
    isEnabled: type === "movies",
  });
  const seriesContentQuery = useSeriesContentQuery(id, {
    isEnabled: type === "series",
  });
  const episodeContentQuery = useEpisodeContentQuery(id, {
    isEnabled: type === "episodes",
  });
  const linearContentQuery = useLinearContentQuery(id, {
    isEnabled: type === "linear",
  });

  const query = useMemo(() => {
    if (type === "movies") return movieContentQuery;
    if (type === "series") return seriesContentQuery;
    if (type === "episodes") return episodeContentQuery;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (type === "linear") return linearContentQuery;
    throw new Error("Invalid detail page type");
  }, [
    type,
    movieContentQuery,
    seriesContentQuery,
    episodeContentQuery,
    linearContentQuery,
  ]);

  return query;
};

export default useContentQuery;
